<style lang="less" scoped>
    .selector{
        display: inline-block;
        width: 100%;
    }
    .selector /deep/ .ivu-poptip{
        width: 100%;
    }
    .selector /deep/ .ivu-poptip-rel{
        width: 100%;
    }
    .selector-btn{
        padding-left: 8px;
        text-align: left;
    }
    .select-poptip{
        width: 100%;
    }
    .select-poptip /deep/ .ivu-poptip-rel{
        width: 100%;
    }
    .type-text{
        padding: 10px 0;
        line-height: 1;
        border: none;
        margin-top: -2px;
        &:focus{
            box-shadow: none;
        }
    }
    .account-container{
        margin-top: 5px;
        height: 160px;
        overflow: auto;
    }
    .select-payee-account{
        display: block;
        margin: 5px;
        padding: 3px 6px;
        border: 1px solid #dddee1;
        border-radius: 4px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .select-payee-account:hover{
        background: #e5e5e5;
    }
    .selector-btn-deletable{
        padding-right: 25px;
        .delete-btn {
            display: inline-block;
            width: auto;
            position: absolute;
            top: 50%;
            right: 5px;
            transform: translate(0, -50%);
            &:hover {
                transform: translate(0, -50%) scale(1.5, 1.5);
            }
        }
    }
</style>
<template>
  <div class="selector">
    <Poptip
      class="select-poptip"
      placement="bottom"
      :width="width"
      :trigger="trigger"
      :transfer="transfer"
      @on-popper-show="poperShow"
    >
      <i-button
        class="selector-btn"
        :class="{'type-text': btnType === 'text', 'selector-btn-deletable': deletable}"
        :type="btnType"
        :size="size"
        long
        :disabled="disabled"
      >
        <slot>
          <span class="color-grey">选择...</span>
        </slot>
        <Icon
          v-if="deletable"
          class="delete-btn"
          type="md-close"
          @click.native.stop="del"
        />
        <input
          v-show="false"
          ref="input"
          type="text"
        >
      </i-button>
      <div slot="content">
        <i-input
          v-model="params.search"
          placeholder="搜索"
          @on-enter="innerSearch"
        >
          <Button
            slot="append"
            icon="ios-search"
            :loading="loading"
            @click="innerSearch"
          />
        </i-input>
        <div class="hr" />
        <div
          v-if="type === 'staff'"
          class="account-container"
        >
          <div
            v-for="customer in results"
            :key="customer.id"
            class="select-payee"
          >
            <span>{{ customer.team }} - </span>
            <span>{{ customer.account }}</span>
            <div
              v-if="customer.bank_number"
              class="select-payee-account"
              @click="setPayeeUser(customer, 'bank')"
            >
              <span>{{ customer.bank }} - </span>
              <span>{{ customer.bank_account ? customer.bank_account : customer.account }} - </span>
              <span>{{ customer.bank_number }}</span>
            </div>
            <div
              v-if="customer.bank2_number"
              class="select-payee-account"
              @click="setPayeeUser(customer, 'bank2')"
            >
              <span>{{ customer.bank2 }} - </span>
              <span>{{ customer.bank2_account ? customer.bank2_account : customer.account }} - </span>
              <span>{{ customer.bank2_number }}</span>
            </div>
            <div
              v-if="customer.alipay"
              class="select-payee-account"
              @click="setPayeeUser(customer, 'alipay')"
            >
              <span>支付宝 - </span>
              <span>{{ customer.account }} - </span>
              <span>{{ customer.alipay }}</span>
            </div>
            <div v-if="!customer.bank_number && !customer.alipay">
              <span>该员工没有录入银行信息</span>
            </div>
          </div>
        </div>
        <div
          v-else
          class="account-container"
        >
          <div
            v-for="company in results"
            :key="company.id"
            :class="{'color-error': company.is_abnormal}"
          >
            <div class="text-bold">
              <span>{{ company.name }}</span>
              <span v-if="company.company_type === 0">- {{ company.id_number || '未录入证件信息' }}</span>
            </div>
            <div v-if="company.is_abnormal">
              <span>已被列入黑名单: </span>
              <span v-html="company.abnormal_reason" />
            </div>
            <div
              v-for="account in company.payee_company_accounts"
              :key="account.id"
              class="select-payee-account"
              @click="setPayeeCompany(company, account)"
            >
              <span>{{ account.bank }} - </span>
              <span>{{ account.account }} - </span>
              <span>{{ account.bank_number }}</span>
              <span
                v-if="account.bank_type === 0 && !account.bank_code"
                class="color-error"
              >
                (未录入联行号，可能会导致无法付款)
              </span>
            </div>
          </div>
        </div>
        <div v-show="loading">
          <Spin fix />
        </div>
        <div
          v-if="!results.length"
          class="color-grey text-center"
        >
          无搜索结果
        </div>
      </div>
    </Poptip>
  </div>
</template>
<script>
  export default {
    props: {
      trigger: {
        type: String,
        default: 'click'
      },
      type: {
        // company: 公司供应商, person: 个人供应商, staff: 公司员工
        type: String,
        required: true
      },
      apply_user_id: {
        type: Number,
        default: 0
      },
      btnType: {
        type: String
      },
      size: {
        type: String
      },
      width: {
        type: [Number, String],
        default: 400
      },
      disabled: {
        type: Boolean,
        default: false
      },
      transfer: {
        type: Boolean,
        default: false
      },
      deletable: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        params: {
          search: '',
          type: '',
          apply_user_id: 0
        },
        results: [],
        loading: false
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
    },
    watch: {
      type() {
        this.init();
        this.innerSearch();
      },
      apply_user_id() {
        this.init();
        this.innerSearch();
      }
    },
    created() {
      this.init();
    },
    mounted() {
      //
    },
    methods: {
      init() {
        this.params.type = this.type;
        this.params.apply_user_id = this.apply_user_id;
      },
      poperShow() {
        if (this.results.length === 0) {
          this.innerSearch();
        }
      },
      // 暴露给外部的接口
      search(search) {
        this.params.search = search;
        this.innerSearch();
      },
      innerSearch() {
        if (this.loading) return;
        this.loading = true;
        if (this.type === 'staff') {
          Util.ajax.get(Util.api.query_customer_with_customer_account, {
            params: this.params
          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              this.results = res.data;
            } else {
              this.$Modal.error({title: '错误', content: res.msg});
            }
          }).catch((e) => {
            this.$Modal.warning({title: '错误', content: e.message});
          }).finally(() => {
            this.loading = false;
          });
        } else {
          Util.ajax.get(Util.api.query_payee_company_account, {
            params: this.params
          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              const data = res.data;
              this.results = data.payee_companies;
            } else {
              this.$Modal.warning({title: '错误', content: res.msg});
            }
          }).catch((e) => {
            this.$Modal.warning({title: '错误', content: e.message});
          }).finally(() => {
            this.loading = false;
          });
        }
      },
      setPayeeCompany(company, account) {
        const account_obj = {};
        account_obj.payee_user_id = 0;
        account_obj.payee_user = '';
        account_obj.payee_company_id = company.id;
        account_obj.payee_company = company.name;
        account_obj.payee_company_account_id = account.id;
        account_obj.payee_bank = account.bank;
        account_obj.payee_account_name = account.account;
        account_obj.payee_bank_number = account.bank_number;
        this.$emit('on-change', account_obj);
        this.$parent.$emit('on-form-blur');
        document.body.click();
      },
      setPayeeUser(customer, bank) {
        const account_obj = {};
        account_obj.payee_company_id = 0;
        account_obj.payee_company = '';
        account_obj.payee_company_account_id = 0;
        account_obj.payee_user_id = customer.id;
        account_obj.payee_user = customer.account;
        if (bank === 'bank') {
          account_obj.payee_bank = customer.bank;
          account_obj.payee_bank_number = customer.bank_number;
          account_obj.payee_account_name = customer.bank_account ? customer.bank_account : customer.account;
        } else if (bank === 'bank2') {
          account_obj.payee_bank = customer.bank2;
          account_obj.payee_bank_number = customer.bank2_number;
          account_obj.payee_account_name = customer.bank2_account ? customer.bank2_account : customer.account;
        } else if (bank === 'alipay') {
          account_obj.payee_bank = '支付宝';
          account_obj.payee_bank_number = customer.alipay;
          account_obj.payee_account_name = customer.account;
        } else {
          console.error('未定义银行类型');
        }
        this.$emit('on-change', account_obj);
        this.$parent.$emit('on-form-blur');
        document.body.click();
      },
      del() {
        const account_obj = {};
        account_obj.payee_user_id = 0;
        account_obj.payee_user = '';
        account_obj.payee_company_id = 0;
        account_obj.payee_company = '';
        account_obj.payee_company_account_id = 0;
        account_obj.payee_bank = '';
        account_obj.payee_account_name = '';
        account_obj.payee_bank_number = '';
        this.$emit('on-change', account_obj);
        this.$parent.$emit('on-form-blur');
        document.body.click();
      }
    }
  }
</script>
